<!-- #region HTML -->
<template>
  <div id="material-kit">

    <!-- #region Navbar -->
    <div :class="{ 'nav-open': NavbarStore.showNavbar }">
      <router-view name="header" :signed-in="signedIn" @callSignout="signout" />
    </div>
    <!-- #endregion Navbar -->

    <!-- #region Main Content -->
    <!-- 認証済みの時はメインの画面を表示 -->
    <div id="app">
      <router-view :username="username" :signed-in="signedIn" :email="email" @callSignin="signin"
        @callSignout="signout"></router-view>
    </div>
    <!-- #endregion Main Content -->

    <!-- #region Footer -->
    <router-view name="footer" />
    <!-- #endregion Footer -->

  </div>
</template>

<!-- #endregion -->

<!-- #region JavaScript -->
<script>
import { Auth, Hub } from 'aws-amplify'

window.LOG_LEVEL = 'WARN'

export default {
  name: 'App',
  data() {
    return {
      signedIn: false,
      username: '',
      email: '',
    }
  },
  async beforeCreate() {
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.username = cognitoUser.username
      this.email = cognitoUser.attributes.email
    } catch (err) {
      this.signedIn = false
    }
    
    // Listen to auth events to automatically update UI state
    Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signOut') {
        this.signedIn = false
        this.username = null
        this.email = null
      }
    })
  },
  methods: {
    signin(user) {
      this.signedIn = true
      this.username = user.username
      this.email = user.attributes.email
    },
    signout() {
      this.signedIn = false
      this.username = null
      this.email = null
    },
  },
}
</script>
<!-- #endregion -->

<!-- #region CSS -->

<style>
#material-kit {
  font-family: var(--default-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

h1 {
  margin-top: 30px !important;
  margin-bottom: 0 !important;
}

.md-card .md-card-actions {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.md-card-actions .md-button .md-ripple {
  padding: 6px 18px !important;
}

.md-card-actions .md-button .md-ripple .md-button-content {
  padding-top: 5px;
  font-size: small;
}
</style>
<!-- #endregion -->